<template lang="html">
  <!-- Default template -->
  <header v-if="!isSpecialTemplate"
          class="Header">
    <div class="HeaderLogo">
      <Logo :color="pageColor" />
      <Trigger :color="pageColor"
               title="Open Menu" />
    </div>
    <Slideshow :color="pageColor" />
    <AnniversaryNote v-if="pageData.id == 1" />
  </header>

  <!-- Foundation Header template for is_menu_sub = 34 -->
  <FoundationHeader v-else />
</template>

<script>
import Slideshow from "@/components/Slideshow/SlideshowSlideshow.vue";
import Logo from "@/components/Elements/ElLogo.vue";
import Trigger from "@/components/Elements/ElNavigationTrigger.vue";
import AnniversaryNote from "@/components/Elements/ElAnniversaryNote.vue";
import FoundationHeader from "@/components/Elements/ElFoundationHeader.vue";
import { mapGetters } from "vuex";

export default {
  components: {
    Slideshow,
    Logo,
    Trigger,
    AnniversaryNote,
    FoundationHeader,
  },
  data() {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
    };
  },
  computed: {
    ...mapGetters(["pageData", "pageRoutes"]),
    pageColor() {
      if (this.windowWidth > this.windowHeight) {
        return this.pageData.is_color;
      } else return this.pageData.is_color_mobile;
    },
    isSpecialTemplate() {
      // return false;
      // TODO TURN BACK ON FOR SPECIAL SLIDESHOW HEADER FOR FOUNDATION PAGES
      const matchingPageRoute = this.pageRoutes.find(route => route.id === this.pageData.id);
      if (this.pageData.options.link == "press-details") return true; else
        return matchingPageRoute && matchingPageRoute.is_menu_sub === 34;
    },
  },
  methods: {
    onResize() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    },
    navigate(i) {
      if (this.$route.path == this.navi[i].path) {
        this.scrollDown();
      } else {
        this.$router.push({ path: this.navi[i].path });
      }
    },
    scrollDown() {
      let newPos;
      if (window.innerWidth > 600) {
        newPos = window.innerHeight - 30;
      } else {
        newPos = window.innerHeight;
      }
      window.scrollTo({
        top: newPos,
        left: 0,
        behavior: "smooth",
      });
    },
  },
  created() {
    window.addEventListener("resize", this.onResize);
  },
  unmounted() {
    window.removeEventListener("resize", this.onResize);
  },
};
</script>

<style lang="css" scoped>
/* HEADER */
.Header {
  position: relative;
  width: 100%;
  height: 100vh;
  max-height: -webkit-fill-available;
  padding: 0;
  margin: 0;
}

.HeaderLogo {
  position: absolute;
  z-index: 999999999;
  top: 24px;
  left: 24px;
  display: grid;
  width: calc(100% - 48px);
  grid-template-columns: auto min-content;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

.Trigger {
  cursor: pointer;
  user-select: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}

@media only screen and (min-width: 768px) {
  .Header {
    height: calc(100vh - 38px);
  }
}
</style>
